import React from "react"; 
import { Spinner } from "reactstrap";
import { Button } from "../../../components/Component";

const MyButton = ({isLoading,mode,onClick,type}) => {
  return (
    <div className="form-group" style={{ marginTop: "31px" }}>
      <Button disabled={isLoading} color="primary" size="md" onClick={onClick} type={type}>
        {isLoading ? <Spinner size="sm" color="light" /> : mode == "Add" ? "Save" : "Update"}
      </Button>
    </div>
  );
};

export default MyButton;

